export const baseUrl = process.env.REACT_APP_BASE_URL
export const apiUrl = process.env.REACT_APP_API_URL
export const cloudfrontUrl = process.env.REACT_APP_S3_IMAGE_PREFIX
